import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../../models';

/** Representa o Filter da entidade RegiaoGeograficaIntermediaria */
export class RegiaoGeograficaIntermediariaFilter implements Filter {
    idEstado: number;

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Estado
        if (this.idEstado) {
            params = params.append('idEstado', this.idEstado.toString());
        }

        return params;
    }

    clear() {
        this.idEstado = null;
    }
}

